// extracted by mini-css-extract-plugin
export var extra = "style-module--extra--e3343";
export var registration = "style-module--registration--60a86";
export var registration__bottom = "style-module--registration__bottom--d3b79";
export var registration__info = "style-module--registration__info--90ef0";
export var registration__text = "style-module--registration__text--036de";
export var registration__textAccent = "style-module--registration__text--accent--c940e";
export var registration__textLineThrough = "style-module--registration__text--line-through--e0ba2";
export var registration__textSmall = "style-module--registration__text--small--28ae3";
export var registration__textSmall2 = "style-module--registration__text--small-2--148b1";
export var registration__textSubtitle = "style-module--registration__text--subtitle--c61f5";
export var registration__title = "style-module--registration__title--4e756";
export var registration__top = "style-module--registration__top--3c77b";
export var registration__widget = "style-module--registration__widget--02726";
export var registration__wrap = "style-module--registration__wrap--c317c";
export var rocket = "style-module--rocket--14ea8";